import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth-routes/admin/projectPhases')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/projectPhase' })
  },
})
